import { ComponentProps } from 'react';
import clsx from 'clsx';
import { OpSkeleton } from 'new-components/DLS/OpSkeleton/OpSkeleton';
import { EntryZoneManager } from 'new-components/EntryZoneManager/EntryZoneManager';
import { useOpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

import './OpFormEntryZoneManager.scss';

interface OpFormDataEntryZoneManagerProps
  extends Pick<
      ComponentProps<typeof OpForm.Item>,
      'name' | 'tooltip' | 'rules' | 'validateTrigger'
    >,
    ComponentProps<typeof EntryZoneManager> {
  formItemClassName?: string;
  isLoading?: boolean;
}

export const OpFormEntryZoneManager = ({
  // Form Item props
  name,
  tooltip,
  rules,
  validateTrigger,
  formItemClassName,

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  disabled,
  orgId,
  zoneId,
}: OpFormDataEntryZoneManagerProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useOpFormContext();

  return (
    <OpForm.Item
      className={clsx('op-form-data-fetch-transfer', formItemClassName)}
      name={name}
      tooltip={tooltip}
      rules={rules}
      validateTrigger={validateTrigger}
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Input active block />
      ) : (
        <EntryZoneManager
          orgId={orgId}
          zoneId={zoneId}
          disabled={isReadOnly || disabled}
        />
      )}
    </OpForm.Item>
  );
};
